import { Transition } from "@headlessui/react";

import { useState, useEffect } from "react";

import { Tooltip } from "@mui/material";

import { useAppDispatch, useAppSelector, useMediaQuery } from "../../../hooks";
import {
  reset,
  selectUser,
  setToken,
  setUser,
} from "../../../states/slices/authReducer";

import { useLocation, useNavigate } from "react-router-dom";

// import { FaHome } from "react-icons/fa";

import { Link } from "react-router-dom";

import { LISPENDES_LOGO_ANAMBRA, LOG_OUT, PROFILE } from "../../../assets";
import {
  courtSidebarData,
  individualSidebarData,
  superAdminSideBar,
} from "../../../constants";
import { UserType } from "../../../utils-func/enums";

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  setOpen: any;
}

const Sidebar = (props: SidebarProps) => {
  const { onClose } = props;
  const user = useAppSelector(selectUser);

  const dispatch = useAppDispatch();

  const [addFolderModal, setAddFolderModal] = useState(false);

  const isMobileView = useMediaQuery("(max-width: 640px)");
  const isTabletView = useMediaQuery("(max-width: 840px)");

  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();

  const swithSidebarData = () => {
    switch (user?.type) {
      case UserType.INDIVIDUAL:
        return individualSidebarData;
      case UserType.ADMIN:
        return superAdminSideBar;
      case UserType.COURT_STAFF:
        return courtSidebarData;

        break;

      case UserType.COMPANY:
        return individualSidebarData;

      default:
        return individualSidebarData;
        break;
    }
  };

  return (
    <>
      {isMobileView || isTabletView ? (
        <Transition
          as="div"
          className="fixed z-50 h-full w-80 flex-none bg-brand-light lg:static"
          enter="transition-all ease-in duration-300"
          enterFrom="transform -translate-x-full"
          enterTo="transform -translate-x-0"
          leave="transition-all ease-out duration-300"
          leaveFrom="transform -translate-x-0"
          leaveTo="transform -translate-x-full"
          show={props.open}
        >
          {/* mobile screen section */}

          <div className="w-[250px] shadow-sm h-screen bg-[#F7F8F9] border border-[#E9EAEB] flex flex-col items-start justify-between">
            <div className="flex items-start px-3 mt-10 flex-col gap-y-11 w-full">
              <img
                src={LISPENDES_LOGO_ANAMBRA}
                className="w-[200px] h-[30.2px] object-contain"
                alt=""
              />
              <div className="flex flex-col w-full gap-y-4">
                {swithSidebarData().map((item) => (
                  <Link
                    to={item.path}
                    onClick={onClose}
                    className={`flex items-center gap-x-3  ${
                      pathname === item.path && "bg-globalGold shadow-md"
                    } cursor-pointer w-full p-3 rounded-lg `}
                  >
                    <img
                      src={
                        pathname === item.path
                          ? item.activeIcon
                          : item.inactiveIcon
                      }
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                    <span
                      className={`text-sm font-medium  ${
                        pathname === item.path && "text-white"
                      }`}
                    >
                      {item.title}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
            <div className="w-full p-1 flex items-center gap-x-2 border-t border-[#E5E5E5]">
              <img
                src={PROFILE}
                className="w-[40px] h-[40px] rounded-full object-cover"
                alt=""
              />
              <div className="flex flex-col items-start w-full">
                <span className="text-sm font-semibold">{user?.name}</span>
                <span className="text-xs font-normal text-[#72777A]">
                  {user?.email && user?.email.length > 15
                    ? `${user?.email?.slice(0, 15)}...`
                    : user?.email}
                </span>
              </div>
              <Tooltip title="Log out">
                <img
                  src={LOG_OUT}
                  className="w-[20px] h-[20px] cursor-pointer"
                  onClick={() => {
                    dispatch(setToken(""));
                    dispatch(setUser(null));
                    navigate("/sign-in");
                  }}
                  alt=""
                />
              </Tooltip>
            </div>
          </div>
        </Transition>
      ) : (
        <div className="min-w-[250px] shadow-sm h-screen bg-[#F7F8F9] border border-[#E9EAEB] flex flex-col items-start justify-between">
          <div className="flex items-start px-3 mt-10 flex-col gap-y-11 w-full">
            <img
              src={LISPENDES_LOGO_ANAMBRA}
              className="w-[200px] h-[30.2px] object-contain"
              alt=""
            />
            <div className="flex flex-col w-full gap-y-4">
              {swithSidebarData().map((item) => (
                <Link
                  to={item.path}
                  className={`flex items-center gap-x-3  ${
                    pathname === item.path && "bg-globalGold shadow-md"
                  } cursor-pointer w-full p-3 rounded-lg `}
                >
                  <img
                    src={
                      pathname === item.path
                        ? item.activeIcon
                        : item.inactiveIcon
                    }
                    className="w-[20px] h-[20px]"
                    alt=""
                  />
                  <span
                    className={`text-sm font-medium  ${
                      pathname === item.path && "text-white"
                    }`}
                  >
                    {item.title}
                  </span>
                </Link>
              ))}
            </div>
          </div>
          <div className="w-full p-1 flex items-center justify-between gap-x-2 border-t border-[#E5E5E5]">
            <img
              src={PROFILE}
              className="w-[40px] h-[40px] rounded-full object-cover"
              alt=""
            />
            <div className="flex flex-col items-start">
              <span className="text-sm font-semibold">{user?.name}</span>
              <span className="text-xs font-normal text-[#72777A]">
                {user?.email && user?.email.length > 17
                  ? `${user?.email?.slice(0, 17)}...`
                  : user?.email}
              </span>
            </div>
            <Tooltip title="Log out">
              <img
                src={LOG_OUT}
                className="w-[20px] h-[20px] cursor-pointer"
                onClick={() => {
                  dispatch(setToken(""));
                  dispatch(setUser(null));
                  navigate("/sign-in");
                }}
                alt=""
              />
            </Tooltip>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
